import React from "react";

interface Props {
  text: String;
  value: string;
}

const Card = ({ text, value }: Props) => {
  return (
    <div className="flex flex-col rounded-md gap-2 shadow-md py-4 px-8 font-inter bg-main-black">
      <h2 className="text-sm text-light-gray">{text}</h2>
      <p className="text-2xl font-bold text-main-white">{value}</p>
    </div>
  );
};

export default Card;
